import React from 'react';
import './winnings.css';
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import infobutton from '../../../../assets/images/info.png'
function Winnings({ data, handleDrawerOpen }) {
	const [sucessCopy, setSucessCopy] = useState(false);
	const text = data?.code;
	const textcopy = (txt) => {
		var dummy = document.createElement('textarea');
		document.body.appendChild(dummy);
		dummy.value = txt;
		dummy.select();
		document.execCommand('copy');
		document.body.removeChild(dummy);
		setSucessCopy(true);
		toast.success('Copied to clipboard', {
			position: 'bottom-center',
			autoClose: 500,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: 'colored',
			bottom: '26px',
			width: '79%',
			left: '45px',
		});
	};
	return (
		<>
			<div className="cardCouponWinner">
				<div className="winnerHeader">
					<img src={data?.logo} alt="img" width={40}/>
					<h4>{data?.winningText}</h4>
				</div>
				<div className="winnerBody">
					<h4><span>Your voucher code</span> {text}</h4>
					<button onClick={() => textcopy(text)}>Copy Code</button>
				</div>
				<div className="winnerFooter">
					<button onClick={() => handleDrawerOpen(data)}>
						<img src={infobutton} alt="info" width={16}/>
						How to Redeem
					</button>
				</div>
			</div>
			{sucessCopy &&
				<ToastContainer
					position="bottom-center"
					autoClose={2000}
					hideProgressBar={false}
					newestOnTop={false}
					// closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
					theme="colored"
					bottom="26px"
					width="79%"
					left="45px"
				/>
			}
		</>

	);
}
export default Winnings;
